import * as React from "react";
import {
    Grid,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent
} from "components/controls/widget";
import { FormControl, buildFormControlProps } from "components/controls/FormControl";
import { hasFlag } from "components/state/types";
import { useMemberValidation } from "../../../../../../member-validation/store";
import { MemberValidationState } from "../../../../../../member-validation/entity";
import { useUIContext } from "../../../../../../context/store";
import { useMemberEmail } from "./store";
import { useMemberDetail } from "../../store";


const UpdateDialog = () => {
    const [memberState] = useMemberDetail();
    const [state, actions] = useMemberEmail();
    const [validationState, validationActions] = useMemberValidation();
    const idtClena = memberState.entity.idtClena;

    React.useEffect(() => {
        if (validationState.emailValidationRequestSucceeded) {
            actions.changeDialogState(false);
        }
    }, [validationState.emailValidationRequestSucceeded]);

    React.useEffect(() => {
        actions.setErrors(validationState.errors);
    }, [validationState.loadFailure]);

    const disable = validationState.loading;

    const fieldDef = buildFormControlProps("email", { 'email': { label: 'Nový email' } }, state, actions);

    return <Dialog open={state.showDialog} scroll="paper" >
        <DialogTitle>{'Změna emailové adresy'}</DialogTitle>
        <DialogContent>
            <FormControl {...fieldDef} autoFocus />
        </DialogContent>
        <DialogActions>
            <Button color="primary" variant="contained" onClick={() => validationActions.sendEmailValidationRequest(idtClena, state.entity.email)} disabled={disable}>{'Uložit a zahájit ověření'}</Button>
            <Button variant="contained" onClick={() => actions.changeDialogState(false)} disabled={disable}>{'Ponechat stávající email'}</Button>

        </DialogActions>
    </Dialog>;
}


const View = () => {

    const [{ entity }] = useMemberDetail();
    const [memberValidationState] = useMemberValidation();
    const [{ showDialog }, { changeDialogState }] = useMemberEmail();
    const [uiContextState] = useUIContext();

    const validationState = memberValidationState.entity.state;

    const disable = showDialog;

    const validOrPending = hasFlag(validationState, MemberValidationState.EmailValidAndPending);
    const pending = hasFlag(validationState, MemberValidationState.EmailPending);

    const email = validOrPending
        ? memberValidationState.entity.email + (pending ? " (nový, čeká na ověření)" : " (ověřeno)")
        : entity.email;

    const userAndMemberIdtEquals = uiContextState.data.member.userMemberIdt === entity?.idtClena;
    const showValidationControls = validOrPending && userAndMemberIdtEquals;

    return <Grid container direction="column">
        <Grid item>
            <Grid container direction="row" alignItems="center" spacing={8}>
                <Grid item>
                    {email}
                </Grid>
                {showValidationControls && <Grid item>
                    <Button variant="contained" size="small" onClick={() => changeDialogState(true)} disabled={disable}>{'Změnit'}</Button>
                </Grid>}
                <UpdateDialog />
            </Grid>
        </Grid>
        {showValidationControls && pending && <Grid item>
            <Typography variant="subtitle2">{'Na adresu nového emailu jsme Vám poslali ověřovací zprávu. Prosíme, ověřte svůj nový email kliknutím do odkazu ve zprávě.'}</Typography>
        </Grid>}

    </Grid>

}

export {
    View as EmailView
}